import styled from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';

export const Section = styled.div`
  padding: 1.5rem 2rem;
  border-bottom: 1px solid ${colors.borderLight};
  
  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    padding: 1.25rem 1.5rem;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 1.2rem;
  color: ${colors.darkBlue};
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  font-weight: 600;
  
  svg {
    font-size: 1.2rem;
    color: ${colors.lightBlue};
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(280px, 100%), 1fr));
  gap: 1rem;
`;

export const InfoItem = styled.div`
  padding: 1rem;
  border-radius: 12px;
  background: ${colors.backgroundLight};
  transition: all 0.2s ease;

  &:hover {
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  label {
    display: block;
    font-size: 0.75rem;
    color: ${colors.textMuted};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }
  
  span {
    display: block;
    font-size: 1rem;
    color: ${colors.darkGray};
    font-weight: 500;
    word-break: break-word;
  }

  @media (max-width: 768px) {
    padding: 0.875rem;
    
    span {
      font-size: 0.9rem;
    }
  }
`;